import React from 'react';
import './styles.scss';
import { useLocaleContext } from 'context/LocaleContext';

type TagValue = {
    key: string;
    id: string;
    label?: React.ReactNode;
};

interface TagBuilderProps {
    setTags: (tags: TagValue[]) => void;
    tags: TagValue[];
    form: { setFieldsValue: (values: Record<string, unknown>) => void };
    tempFilter: Record<string, unknown>;
    setTempFilter: (next: Record<string, unknown>) => void;
    removeTag: (id: string) => void;
}

const TagBuilder: React.FC<TagBuilderProps> = ({
    setTags,
    tags,
    form,
    tempFilter,
    setTempFilter,
    removeTag
}) => {
    const { locale } = useLocaleContext();

    const normalizeLabel = (label: React.ReactNode): React.ReactNode => {
        if (typeof label !== 'string') return label;

        try {
            const parsed: unknown = JSON.parse(label);
            if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
                const record = parsed as Record<string, unknown>;
                const byLocale = record[locale];
                if (typeof byLocale === 'string' && byLocale.trim().length) return byLocale;

                const first = Object.values(record).find((v) => typeof v === 'string' && v.trim().length);
                if (typeof first === 'string') return first;
            }
        } catch {
            // not json
        }

        return label;
    };

    const renderTags = () => {
        return tags.map((value) => {
            const key = `${value.key}-${value.id}`;

            if (value.label) {
                return (
                    <div key={key} className={'report-filter-tag flex gap-5 align-center'}>
                        {normalizeLabel(value.label)}
                        <i onClick={() => removeFilter(value.id)} className="fa-duotone fa-xmark"></i>
                    </div>
                )
            } else {
                return;
            }
        })
    }

    const removeFilter = (id: string) => {
        const temp = tags.filter((el) => el.id !== id)

        const deleteValue = tags.filter((el) => el.id === id)[0]

        if ((deleteValue.key).toLowerCase().includes('date') || (deleteValue.key).toLowerCase().includes('bool') || (deleteValue.key).toLowerCase().includes('count')) {
            form.setFieldsValue({
                [deleteValue.key]: null
            })
        } else if (deleteValue.key === 'enrollmentTypeStatus') {
            form.setFieldsValue({
                [deleteValue.key]: null
            })
        } else {
            let nextValue: unknown = [];

            if (deleteValue.key.toLowerCase().includes('status')) {
                nextValue = String(tempFilter[deleteValue.key] ?? '')
                    .split(',')
                    .filter((el) => el !== deleteValue.id)
                    .join(',')
            } else {
                nextValue = Array.isArray(tempFilter[deleteValue.key])
                    ? (tempFilter[deleteValue.key] as unknown[]).filter((el) => String(el) !== deleteValue.id)
                    : []
            }

            setTempFilter({...tempFilter, [deleteValue.key]: nextValue})
        }
        removeTag(id)
        setTags(temp)
    }

    return (
        <div className={'flex gap-5 flex-wrap'}>
            {renderTags()}
        </div>
    );
};

export default TagBuilder;